import React from 'react';

const PageSupport = () => {
      return (
          <div className="TCWrapper" style={{ marginBottom: "5rem"}}>
          <div>
            <div>
                <div>
                  <h1>Support</h1>
                  <p>Updated at 2026-08-23</p>
                  <br/>
                  <p className="p8"><span className="s1">
                    Need help with mattool.in or the Where Is My Bus app? We are happy to hear from you.
                  </span></p>
                  <p className="p9"><br/></p>

                  <h1>Where Is My Bus</h1>
                  <p className="p10"><span className="s1">
                    Where Is My Bus is a local bus timetable app for Kerala. You can search a route and see scheduled timings. It works without an account.
                    <br/><br/>
                    If a timing looks wrong, a stop is missing, or the app is not working as expected, email us with the route and what you saw. That helps us fix it faster.
                  </span></p>
                  <p className="p9"><br/></p>

                  <h1>Contact</h1>
                  <p className="p10"><span className="s1">The fastest way to reach us:</span></p>
                  <ul className="ul1">
                      <li className="li16"><span className="s3">Email: <a href="mailto:contact.mattool.live@gmail.com">contact.mattool.live@gmail.com</a></span></li>
                      <li className="li16"><span className="s3">Website: <a href="https://mattool.in">https://mattool.in</a></span></li>
                      <li className="li16"><span className="s3">Privacy Policy: <a href="https://mattool.in?page=privacy">https://mattool.in?page=privacy</a></span></li>
                      <li className="li16"><span className="s3">Terms &amp; Conditions: <a href="https://mattool.in?page=tc">https://mattool.in?page=tc</a></span></li>
                  </ul>
                </div>
            </div>
          </div>
          </div>
        )
}

export default PageSupport
